import React from 'react'
import { useTranslation } from 'i18n'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  Box,
} from '@mui/material'
import { X } from 'lucide-react'
import { GenerateBarcodeResponse } from '../../../../services/incomm/barcode'

export type IncommOfferModalVariant =
  | 'already_requested'
  | 'expired'
  | 'barcode_limit'
  | 'clip_limit_exceeded'
  | 'service_unavailable'

interface IncommOfferModalCheckProps {
  variant: IncommOfferModalVariant
  barcodeResponse?: GenerateBarcodeResponse | null
  open: boolean
  onClose: () => void
}

const MODAL_CONTENT_KEYS: Record<IncommOfferModalVariant, string> = {
  already_requested: 'alreadyRequested',
  expired: 'expired',
  barcode_limit: 'barcodeLimit',
  clip_limit_exceeded: 'clipLimitExceeded',
  service_unavailable: 'serviceUnavailable',
}

export const IncommOfferModalCheck = ({
  variant,
  open,
  onClose,
}: IncommOfferModalCheckProps) => {
  const { t } = useTranslation('incommOffer')
  const shouldShowModal = open

  if (!shouldShowModal) {
    return null
  }

  const contentKey = MODAL_CONTENT_KEYS[variant]
  const title = t(`statusModal.${contentKey}.title`)
  const description = t(`statusModal.${contentKey}.description`)

  return (
    <Dialog
      onClose={(_, reason) => reason !== 'backdropClick' && onClose()}
      open={shouldShowModal}
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ position: 'relative' }}>
        <DialogTitle>{title}</DialogTitle>
        <IconButton
          aria-label={t('common:close')}
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <X size={24} />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography variant="body1">{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          {t('statusModal.acknowledge')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
